import styled from "styled-components";

export const InfoWrapper = styled.div`
  width: fit-content;
  padding: 6px 8px;
  background: #e8e8e8;

  > span {
    color: #ed0000;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }

  > p {
    color: #20332f;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }
`;
